import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/store/userStore'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/auto-login',
    name: 'AutoLogin',
    component: () => import('@/components/AutoLogin.vue'),
    beforeEnter:  async (to, from, next) => {
      const userStore = useUserStore();
      const ticketNumber = to.query.ticketNumber;
      const hash = to.query.hash;
      try {
        
        await userStore.autoLogin(ticketNumber, hash);

        next({ name: 'Dashboard' });
      } catch {
        next({ name: 'Home'});
      }
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path:'/:pathMatch(.*)*',
    name: 'NotFound' ,
    component:  () => import(/* webpackChunkName: "error" */ '@/views/NotFound.vue'),
    beforeEnter: (to, from, next) => {
      if (to.path.includes('auto-login')){
        console.log("Auto-login route error")
      }
      next();
    }
  },
  {
    path: '/barrierefreiheit',
    name: 'AccessibilityStatement',
    component: () => import(/* webpackChunkName: "accessibility" */ '@/views/AccessibilityStatement.vue'),
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/ContactView.vue'),
  }
  // {
  //   path: '/impressum',
  //   name: 'Impressum',
  //   component: () => import(/* webpackChunkName: "impressum" */ '@/views/ImpressumView.vue'),
  // },
  // {
  //   path: '/datenschutz',
  //   name: 'Datenschutz',
  //   component: () => import(/* webpackChunkName: "datenschutz" */ '@/views/DatenschutzView.vue'),
  // },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()

  if (to.name === 'AutoLogin') {
    next();
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!userStore.checkAuth()) {
      next({ name: 'Home'})
      } else {
        next()
      }
    } else {
      next()
    }
  })

router.afterEach((to) => {
  const userStore = useUserStore()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (userStore.checkAuth()) {
      localStorage.setItem('isAuthenticated', 'true')
    } else {
      localStorage.removeItem('isAuthenticated')
    }
  }
})

export default router
